var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', _vm._l(_vm.getFilters, function (filterData) {
    return _c('b-col', {
      key: filterData.key,
      staticClass: "raft-js-filter-cols"
    }, [_vm.getComponent(filterData.type, filterData.displaySettings.type) ? _c(_vm.getComponent(filterData.type, filterData.displaySettings.type), {
      tag: "component",
      attrs: {
        "filter-data": filterData
      },
      on: {
        "update-filters": _vm.updateFilters
      }
    }) : _vm._e()], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }